import { useId as u, createElementBlock as l, openBlock as i, normalizeClass as r, createCommentVNode as c, renderSlot as n, createElementVNode as g, toDisplayString as o, Fragment as f, renderList as h, unref as y, createTextVNode as v, createVNode as $ } from "vue";
import W from "../../atoms/divider/divider.vue.js";
/* empty css          */
import b from "../../_virtual/_plugin-vue_export-helper.js";
const j = { class: "ds-heading" }, k = {
  key: 0,
  class: "ds-margin-top-24"
}, m = {
  small: 12,
  medium: 6,
  large: 4
}, D = {
  __name: "grid",
  props: {
    items: {
      type: Array,
      required: !0
    },
    columnWidth: {
      type: Object,
      default: () => m,
      validator: (e) => Object.keys(e).every((t) => ["small", "medium", "large"].includes(t))
    },
    centerAligned: {
      type: Boolean,
      default: !1
    },
    title: {
      type: String,
      default: null
    },
    titleWidth: {
      type: Object,
      default: () => m,
      validator: (e) => Object.keys(e).every((t) => ["small", "medium", "large"].includes(t))
    },
    withVerticalDividers: {
      type: Boolean,
      default: !1
    },
    withHorizontalDividers: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = u();
    return (a, V) => (i(), l("div", {
      class: r(["ds-grid-component ds-grid", { "ds-justify-content-center": e.centerAligned }]),
      "data-j-grid": ""
    }, [
      e.title ? (i(), l("div", {
        key: "grid-title",
        class: r(["ds-grid__col", `ds-grid__col--${e.titleWidth.small} ds-md-grid__col--${e.titleWidth.medium} ds-lg-grid__col--${e.titleWidth.large}`])
      }, [
        n(a.$slots, "title", { title: e.title }, () => [
          g("h2", j, o(e.title), 1)
        ], !0)
      ], 2)) : c("", !0),
      (i(!0), l(f, null, h(e.items, (s, d) => (i(), l("div", {
        key: `grid-col-${d + 1}-${y(t)}`,
        class: r(["ds-grid__col", [
          `ds-grid__col--${e.columnWidth.small} ds-md-grid__col--${e.columnWidth.medium} ds-lg-grid__col--${e.columnWidth.large}`,
          {
            "ds-dividers": e.withHorizontalDividers && d !== e.items.length - 1
          }
        ]]),
        "data-j-column": ""
      }, [
        n(a.$slots, "default", {
          item: s,
          index: d
        }, () => [
          v(o(s), 1)
        ], !0),
        e.withVerticalDividers && d !== e.items.length - 1 ? (i(), l("div", k, [
          $(W)
        ])) : c("", !0)
      ], 2))), 128))
    ], 2));
  }
}, A = /* @__PURE__ */ b(D, [["__scopeId", "data-v-bf92fcbb"]]);
export {
  A as default
};
